// extracted by mini-css-extract-plugin
export default {"container":"MOsuCzrt5_CQtYs","csi":"RR0tkftEtiYUAeE"};